import { createApp } from 'vue'
import { createPinia } from 'pinia';

import App from './App.vue'
import './styles/global.css'
import './styles/responsive.css'
import router from './router';


const app = createApp(App)

const pinia = createPinia()

app.use(pinia)      // MUST come before mount
app.use(router)
app.mount('#app');
